import { jsx as _jsx } from "react/jsx-runtime";
import clsx from 'clsx';
import { StarFilled } from '@ant-design/icons';
import { Tooltip } from 'antd';
import { txt } from 'libs/i18n';
import styles from './style.module.less';
const DefaultStar = ({ marginLeft = false }) => (_jsx(Tooltip, { title: txt('default'), children: _jsx(StarFilled, { className: clsx(styles.defaultStar, marginLeft && styles.defaultStarMarginLeft) }) }));
export default DefaultStar;
